import { ACT, PREPARE, WATCH, OUT_OF_SCOPE } from '@/model/rating/recommendations'

export default {
    title: 'Recommendation for action',
    radar: 'To radar',
    [OUT_OF_SCOPE]: 'Out of Scope',
    [ACT]: 'Act',
    [PREPARE]: 'Prepare',
    [WATCH]: 'Watch'
}
